import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Catalogo } from 'src/app/interfaces/interface-bakend/shared/catalogo/catalogo.interface';
import { CatalogoService } from '../../../../../services/shared/catalogo.service';
import { EntidadesKeys } from 'src/app/enum/entidades-keys.enum';
import { GuiMsjService } from 'src/app/services/shared/gui-msj.service';
import Swal from 'sweetalert2';
import { PerfilesService } from 'src/app/services/perfiles/perfiles.service';
import { AuthService } from '@services/auth/auth.service';

@Component({
    selector: 'app-especialidades-listado',
    templateUrl: './especialidades-listado.component.html',
    styleUrls: ['./especialidades-listado.component.scss'],
})
export class EspecialidadesListadoComponent implements OnInit {
    @ViewChild('previousRoute') previousRouteLink: ElementRef;

    /* Data Table*/
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    displayedColumns: string[] = ['especialidad', 'activa', '_id'];
    dataSource: MatTableDataSource<Catalogo>;
    /* Fin Data Table*/

    flagLoaded: boolean = false;
    keyPerfil: string = '';

    constructor(
        private catalogoService: CatalogoService,
        private router: Router,
        private guiMsjService: GuiMsjService,
        private perfilesService: PerfilesService,
        private authService: AuthService
    ) {
        this.dataSource = new MatTableDataSource();
    }

    ngOnInit(): void {
        this.getPerfil().then(() => {
            this.perfilesService.allowedByUserLogon(this.router.url, this.previousRoute, this.keyPerfil);
        });
        this.loadDataPage();
    }

    async ngAfterViewInit() {
        await this.loadDataPage();
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        
        // Agregar esta configuración
        this.dataSource.sortingDataAccessor = (item, property) => {
            if (property === 'activa') {
                // Ordenamos primero los true (1) y luego los false (0)
                return item.logico_1 ? 1 : 0;
            }
            return item[property];
        };
    }

    get previousRoute() {
        const previousRoute = this.previousRouteLink.nativeElement.getAttribute('href');
        return previousRoute;
    }

    async getPerfil() {
        try {
            const user = await this.authService.getUserLogon();
            if (user) {
                const { key } = user?.perfil
                this.keyPerfil = key;
            }
        }
        catch (error) {
            console.log('ABM - Error al obtener el perfil del usuario', error);
            return '';
        }
    }

    async verEspecialidad(_id: string) {
        await this.guiMsjService.msjFormSubmit('Espere');
        Swal.showLoading();
        const especialidad: Catalogo = await this.catalogoService.getFindOne(
            _id
        );
        if (especialidad !== undefined) {
            this.router.navigateByUrl('/especialidad-modificacion');
            this.catalogoService.setConcepto(especialidad);
        }
        else {
            Swal.close();
        }
    }

    async loadDataTable() {
        await this.catalogoService
            .findDescendantsByKey(EntidadesKeys.ESPECIALIDADES)
            .then((especialidades: Catalogo[]) => {
                // Ordenar primero por estado (activos primero) y luego alfabéticamente
                const sortedData = especialidades.sort((a, b) => {
                    // Primero por estado (true primero)
                    if (a.logico_1 === b.logico_1) {
                        return a.concepto.localeCompare(b.concepto); // Orden alfabético
                    }
                    return b.logico_1 ? 1 : -1; // true va antes que false
                });
                
                this.dataSource = new MatTableDataSource(sortedData);
                this.dataSource.sort = this.sort;
                this.dataSource.paginator = this.paginator;
            });
    }

    applyFilter(event: Event) {
        const filterValue = (event?.target as HTMLInputElement)?.value.trim().toLowerCase();
        
        // Filtro personalizado
        this.dataSource.filterPredicate = (data: Catalogo, filter: string) => {
            return data.concepto.toLowerCase().includes(filter) || 
                   (data.logico_1 ? 'si' : 'no').includes(filter);
        };
        
        this.dataSource.filter = filterValue;
        
        // Reordenar después de filtrar
        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    async loadDataPage() {
        await this.loadDataTable();
        this.flagLoaded = true;
    }

    toggleActivo(element: any, event: Event) {
        const isChecked = (event.target as HTMLInputElement).checked;
        const estadoOriginal = element.logico_1;
        
        element.logico_1 = isChecked;
    
        const updateData: Catalogo = {
            ...element,
            logico_1: isChecked
        };
    
        this.catalogoService.put(element._id, updateData)
            .then((response: any) => {
                if (!response) {
                    element.logico_1 = estadoOriginal;
                    console.error('Error al actualizar estado - Respuesta vacía del servidor');
                } else {
                    console.log('Estado actualizado correctamente:', response);
                    // Forzar actualización del ordenamiento
                    this.sort.active = this.sort.active; // Triggers change
                }
            })
            .catch((error) => {
                element.logico_1 = estadoOriginal;
                console.error('Error en la actualización:', error);
                // Forzar actualización del ordenamiento
                this.sort.active = this.sort.active; // Triggers change
            });
        
    }
}